import lessRequire from '../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import SelectField from '../../shared/form-elements/multiselect/select';

lessRequire('modules/finances/components/categories-filter.less');

const Form = ({ intl, handleSubmit, pointCategoriesFilterData }) => (
	<form
		action="#"
		className="finances-categories-filter">
		<div className="finances-categories-filter__item">
			<Field
				name="category"
				placeholder={intl('Категория')}
				component={SelectField}
				options={pointCategoriesFilterData.options}
				multi={false}
			/>
		</div>
	</form>
);

Form.propTypes = {
	handleSubmit: PropTypes.func,
	intl: PropTypes.func,
	pointCategoriesFilterData: PropTypes.object
};

export default reduxForm({
	form: 'pointCategoriesFilter'
})(Form);


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/finances/components/point-category-filter.js